import React from 'react';
import { CLOSED_OUTCOMES, pillClassFor } from '../../constants/admissionStatus';

export default function FacilityClosedOutcomeBreakdown({ closedByTerminalOutcome = {} }) {
    const entries = CLOSED_OUTCOMES
        .map((o) => [o, closedByTerminalOutcome[o] || 0])
        .filter(([, n]) => n > 0);

    if (entries.length === 0) {
        return (
            <section className="dashboard-section">
                <h3>Closed outcomes (90d)</h3>
                <p className="dashboard-empty">No closed cases in the last 90 days.</p>
            </section>
        );
    }

    return (
        <section className="dashboard-section">
            <h3>Closed outcomes (90d)</h3>
            <ul className="closed-outcomes-list">
                {entries.map(([outcome, n]) => (
                    <li key={outcome}>
                        <span className={`admission-pill ${pillClassFor(outcome) || ''}`}>{outcome}</span>
                        <span className="closed-outcome-count">{n}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
